const skills = [
    {
        title: "Programming Languages",
        items: [
            "C#",
            "Java",
            "C++",
            "JavaScript",
            "Python",
            "HTML",
            "CSS"
        ]
    },
    {
        title: "Frameworks & Libaries",
        items: [
            "ASP.NET MVC",
            "React",
            "jQuery",
            "Flask",
            "Android",
            "Bootstrap",
            "JavaFx",
            "WPF"
        ]
    },
    {
        title: "Databases",
        items: [
            "T-SQL",
            "Microsoft SQL Server",
            "Azure SQL Database",
            "Google Firebase",
            "SQLite"
        ]
    },
    {
        title: "Tools",
        items: [
            "Git & Github",
            "Microsoft TFS",
            "XML",
            "JSON",
            "AJAX",
            "R",
            "Bash Shell",
            "PowerShell"
        ]
    }
];

export default skills;